import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const DualEllipses = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width="129"
      height="77"
      viewBox="0 0 129 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <circle cx="38.4991" cy="38.4991" r="38.4991" fill="#D3DBF8" />
      <circle cx="89.8308" cy="38.4991" r="38.4991" fill="#F6F7F9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.1654 67.1951C72.0418 60.1456 76.9986 49.9012 76.9986 38.499C76.9986 27.0968 72.0418 16.8523 64.1654 9.80286C56.2891 16.8523 51.3323 27.0968 51.3323 38.499C51.3323 49.9012 56.2891 60.1456 64.1654 67.1951Z"
        fill="#0F1F57"
      />
    </svg>
  </span>
);

export default DualEllipses;
